// Customer profile
const PROFILE = '/profile';
export default PROFILE;